
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Status = () => {
  return (
    <SettingsMetaData propertyName={"Status_invoicesIncoming"} viewPropertyName={"Status"} />
  );
};

export default Status;
